/**
 * O filtro "Situação" da home de Alertas — o recorte **por estado** que a lista e
 * os contadores compartilham (`situation` em `GET /alerts` e `/alerts/summary`).
 *
 * ⚠️ **Os dois têm de receber o mesmo valor.** Até 2026-09-30 a lista filtrava a
 * fila e os cartões contavam todos os estados, e a tela mostrava "4 graves" em cima
 * de uma lista com 1 (achado 1 do QA de 18/09).
 *
 * ⓘ `RECORDED` só tem conteúdo em tenant sem fila (B2C, CINCO SEMPRE). Para a
 * enfermagem de Olinda fica vazio, e isso é certo.
 */
enum AlertSituationEnum {
  /** Na fila ou em atendimento. */
  PENDING = 'pending',
  /** Tratado ou resolvido pela CintIA. */
  RESOLVED = 'resolved',
  /** Gravado sem fila — tenant sem equipe contratada. */
  RECORDED = 'recorded',
}

export default AlertSituationEnum;
